var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-header',{attrs:{"height":"auto"}},[_c('common-header')],1),_c('el-container',{staticClass:"page-content"},[_c('el-aside',{staticClass:"no-top",attrs:{"width":"auto"}},[_c('common-asideVue')],1),_c('el-main',{staticClass:"el-main"},[_c('airticketyudingshenqing-right')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }